interface RBLColorSettingsTableRowProps {
  label: React.ReactNode;
  values: Record<string, { label: string }>;
  dataCyPrefix: string;
}

export const RBLColorSettingsTableRow = ({
  label,
  values,
  dataCyPrefix,
}: RBLColorSettingsTableRowProps) => (
  <div className="vai-flex vai-w-full vai-border-b vai-border-gray-200 vai-pb-4 vai-mb-4 vai-justify-between">
    <div className="vai-w-1/5 vai-flex vai-items-center">
      <span className="vai-text-xl vai-font-medium">{label}</span>
    </div>
    {(['green', 'yellow', 'orange', 'red'] as const).map((color) => (
      <div
        className="vai-w-1/5 vai-flex vai-items-center vai-justify-center"
        key={`${dataCyPrefix}-${color}`}
      >
        <span
          data-cy={`${dataCyPrefix}-rbl-grid-values`}
          data-testid={`${dataCyPrefix}-rbl-grid-values`}
          className="vai-text-center"
        >
          {values[color].label}
        </span>
      </div>
    ))}
  </div>
);
